import { findAvailableLotMatch, resolveCanonicalLotKey } from '../../utils/lotIdentity'

type BiomassKpiLotRow = {
  lot?: string | null
  lotId?: string | null
}

type BiomassKpiLot = {
  id: string
  lotKey?: string | null
}

const toCanonicalLotToken = (value: string | null | undefined): string => {
  const token = resolveCanonicalLotKey(value)
  return token === 'unknown-lot' ? '' : token
}

export const resolveBiomassKpiLotIdentity = (
  row: BiomassKpiLotRow,
  availableLots: ReadonlyArray<BiomassKpiLot>
): { token: string; label: string } => {
  const lotLabel = String(row.lot ?? '').trim()
  const lotId = String(row.lotId ?? '').trim()

  if (lotLabel) {
    const matchedLot = findAvailableLotMatch(lotLabel, availableLots)
    if (matchedLot.status === 'matched') {
      const matchedToken = toCanonicalLotToken(matchedLot.match.lotKey)
      if (matchedToken) {
        return { token: matchedToken, label: lotLabel }
      }
    }

    const labelToken = toCanonicalLotToken(lotLabel)
    if (labelToken) {
      return { token: labelToken, label: lotLabel }
    }
  }

  if (lotId) {
    const matchedLot = availableLots.find((lot) => String(lot.id ?? '').trim() === lotId)
    const matchedLabel = String(matchedLot?.lotKey ?? '').trim()
    const matchedToken = toCanonicalLotToken(matchedLabel || lotId)
    if (matchedToken) {
      return { token: matchedToken, label: matchedLabel || lotId }
    }
  }

  return {
    token: '',
    label: lotLabel || lotId
  }
}